import {BusynessInterface} from "../interfaces/meetings/BusynessInterface";
import {DateTime} from "luxon";
import {Participant} from "./Participant";
import {setDates} from "../helpers/DatesSetter";
import {ParticipantInterface} from "../interfaces/meetings/ParticipantInterface";

export class Busyness implements BusynessInterface{
    beginAt: DateTime;
    endAt: DateTime;
    participantIds: number[];
    participants: Participant[] | null;
    tagColor: string | null;
    title: string;
    type: string;

    #dates: string[] = ['beginAt', 'endAt'];

    constructor(data: BusynessInterface) {
        Object.assign(this, data);
        setDates(this, this.#dates);
        if (this.participants) {
            this.participants = this.participants.map((item: ParticipantInterface) => new Participant(item));
        }
        else {
            this.participants = [];
        }
    }

}